"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.shield = void 0;
var shield = {
  "viewBox": "0 0 1280 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1088 960v-640h-448v1137q119-63 213-137 235-184 235-360zM1280 192v768q0 86-33.5 170.5t-83 150-118 127.5-126.5 103-121 77.5-89.5 49.5-42.5 20q-12 6-26 6t-26-6q-16-7-42.5-20t-89.5-49.5-121-77.5-126.5-103-118-127.5-83-150-33.5-170.5v-768q0-26 19-45t45-19h1152q26 0 45 19t19 45z"
    }
  }]
};
exports.shield = shield;